import {z} from 'zod';

// POST /3.0/users/signout
export const LogoutSchema = z.object({});

export const LogoutResponseSchema = z.string();
export type LogoutResponse = z.infer<typeof LogoutResponseSchema>;
